/**
 * advanced-column-selection-modal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, EventEmitter, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { StdVariable } from "./typed-parameter";
import { FilterNode, OperatorNode, ArgumentNode, ConstantNode } from "./filter-node";
import { TypedData, TypedDataHolder } from "../common/data/typed-data";
import { Operators } from "./operators";

export interface CustomColumnProps
{
		displayName?: string;
		filter?: FilterNode;
}
export interface ColumnSelectionContext extends BSModalContext
{
	variable: StdVariable;
	filterVariables: TypedData[];
}

@Component({
	template: `
<div class="modal-header">
	<button
		type="button"
		class="close"
		(click)="dialog.dismiss()"
		aria-label="Close">
		<span aria-hidden="true">&times;</span>
	</button>
	<h3 class="capitalized modal-title">
			Advanced Column Creator
	</h3>
</div>

<div class="modal-body">
	<div class="form-group">
		<label>Custom column label</label>
		<input
			type="text"
			class="form-control"
			[formControl]="label">
	</div>
	<div *ngIf="variable.cardinality === 1">
		<label>Filter</label>
		<p>
			<em>
				(Collection filters can only be attached to columns whose values are
				lists or sets.)
			</em>
		</p>
	</div>
	<div *ngIf="variable.cardinality !== 1">
		<label>
			Filter
			<span class="btn-group">
				<button
					type="button"
					class="btn btn-default btn-xs"
					(click)="resetFilter()">
					{{filter === null ? "Create Filter" : "Reset Filter"}}
				</button>
				<button
					type="button"
					class="btn btn-danger btn-xs"
					(click)="filter = null"
					[disabled]="filter === null">
					Remove Filter
				</button>
			</span>
		</label>
		<simple-filter-node
			*ngIf="filter !== null"
			[node]="filter"
			[variables]="filterVariables"
			[skipText]="true"
			[forCollection]="variable">
		</simple-filter-node>
		<p *ngIf="filter === null"><em>No filter.</em></p>
	</div>
</div>

<div class="modal-footer">
	<button
		type="button"
		class="btn btn-default"
		(click)="dialog.dismiss()">
		Cancel
	</button>
	<button
		type="button"
		class="btn btn-primary"
		(click)="submit()">
		OK
	</button>
</div>
	`,
	styles: []
})
export class AdvancedColumnSelectionModalComponent
	implements ModalComponent<ColumnSelectionContext>
{
	public variable : StdVariable & {filter?: OperatorNode}

	public filterVariables : TypedData[];

	public filter : FilterNode = null

	constructor (public dialog : DialogRef<ColumnSelectionContext>)
	{
		this.variable = dialog.context.variable;
		this.filterVariables = dialog.context.filterVariables;
		this.label = new FormControl(this.variable.displayName);

		if (this.variable.filter)
		{
			this.filter = this.variable.filter;
		}
	}

	public label : FormControl;

	public submit ()
	{
		let out : CustomColumnProps = {}
		if (this.label.value)
		{
			out.displayName = this.label.value;
		}
		if (this.filter)
		{
			out.filter = this.filter;
		}
		this.dialog.close(out);
	}

	public resetFilter ()
	{
		const opNode = new OperatorNode(
			Operators.get("all of"),
			[],
			true,
			this.filterVariables
		);
		const eqNode = new OperatorNode(
			Operators.get("equals"),
			[],
			false,
			this.filterVariables
		);
		opNode.addChild(0, eqNode);
		eqNode.addChild(0, new ArgumentNode(this.variable));
		this.filter = opNode;
	}
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/aggregation/advanced-column-selection-modal.component.ts